module.exports = __webpack_public_path__ + "static/media/JW-marriot03.4310669e.jpg";